import { useEffect as e } from "react";
//#region src/hooks/useDocumentTitle.ts
var t = (t) => {
	e(() => {
		document && (document.title = t);
	}, [t]);
};
//#endregion
export { t as default };

//# sourceMappingURL=useDocumentTitle.js.map